// extracted by mini-css-extract-plugin
module.exports = {"phoneLink":"CommunicationPhoneLink_phoneLink__3omQO"};